//
// Store dialer (PI box) results in browser via rxdb and sync with testbed postgres
//

import { RxJsonSchema, RxDocument } from 'rxdb';
import { DriveTestSeq } from '../models';


export const driveTestSeqMethods = {
}

export type DriveTestSeqDoc = RxDocument<DriveTestSeq,typeof  driveTestSeqMethods>

export const driveTestSeqSchema: RxJsonSchema<DriveTestSeq> = {
    title: 'dialer result and import status',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        seqid: {
            primary: true,
            type: 'string'
        },
        testPointId: {
            type: 'string'
        },
        userId: {
            type: 'string'
        },
        stage: {
            type: 'string'
        },
        routeId: {
            type: 'string'
        },
        cycle: {
            type: 'number'
        },
        testOrder: {
            type: 'number'
        },
        importTime: {
            type: ['string', 'null']
        },
        startTime: {
            type: ['string', 'null']
        },
        endTime: {
            type: ['string', 'null']
        },
        dialer: {
            type: ['object', 'null']
        },
        status: {
            type: ['string', 'null']
        },
        groupingfield: {
            type: ['string', 'null']
        },
        updatedAt: { type: 'number' }
    },

    required: ['testPointId'],
    
    indexes: [
        'testPointId'
    ]
};

//const testSeqFields = [ ...Object.keys(new TestSeq()), 'deleted' ]
const varDefs = {
    seqid: 'ID!',
    testPointId: 'String',
    userId: 'String', 
    stage: 'String', 
    routeId: 'String', 
    cycle: 'Float', 
    testOrder: 'Float', 
    importTime: 'DateTime', 
    startTime: 'DateTime', 
    endTime: 'DateTime',
    dialer: 'String', 
    status: 'String',
    groupingfield: 'String',
    updatedAt: 'Float',
    deleted: 'Boolean'
}

const varNames = Object.keys(varDefs)

export const driveTestSeqPullQueryBuilder = () => {
    
    const query = 'query FeedForRxdbDriveTestSeqs($lastId: String!, $minUpdatedAt: Float! ){ '+
        'feedForRxdbDriveTestSeqs(lastId: $lastId, minUpdatedAt: $minUpdatedAt ) {' + varNames.join(' ') +'}}';

    return (doc : DriveTestSeq) => {
        const rtn = {
            query,
            variables: {
                lastId: !doc ? '' : doc.seqid,
                minUpdatedAt: !doc ? 0 : doc.updatedAt
            }
        };
        //console.log(`testSeqPullQueryBuilder() updatedAt=${doc?.updatedAt}`);console.dir(rtn)
        return rtn
    };

};

export const driveTestSeqPushQueryBuilder = () => {
    const paramSigs = Object.entries(varDefs).map(([name,type])=>'$'+name+':'+type).join(',')
    const paramBindings = varNames.map(name=>name+':$'+name).join(',')
    const query = 'mutation CreateDriveTestSeqs(' + paramSigs + '){ ' +
        'createDriveTestSeqs(args:[{' + paramBindings + '}]){ seqid, status, updatedAt }}';

    return (doc : DriveTestSeq) => {

        let variables : any = {}
        for( const varName of varNames ) {
            variables[varName] = doc[varName]
        }
        
        const rtn = {
            query,
            variables
        };
        console.log(`driveTestSeqPushQueryBuilder() updatedAt=${doc.updatedAt}`);console.dir(rtn)
        return rtn
    };
};